import React, { useMemo, useState } from "react";
import { Box } from "@mui/material";
import dayjs from "dayjs";
import LGModalCrud from "../LGCrud/LGModalCrud";
import LGModal from "../../molecules/LGModal";
import ShipmentForm from "./ShipmentForm";
import ShipmentEditForm from "./ShipmentEditForm";
import UpdateFileForm from "./ShipmentFilesTable";
import { ManageShipmentContainers } from "./ManageShipmentContainers.tsx";
import ShipmentIncrementalsForm from "./ShipmentIncrementalsForm";
import ShipmentExportModal from "../../molecules/Imports/ShipmentExportModal";
import { deleteShipment, exportShipments, getShipmentList } from "../../api/imports";
import {
  buildShipmentColumnVisibilityModel,
  createShipmentCrudColumns,
} from "./ShipmentCrudColumns";

export default function ShipmentCrudTable({ companyId }) {
  const [exportModalOpen, setExportModalOpen] = useState(false);
  const columns = useMemo(() => createShipmentCrudColumns(), []);

  const columnVisibilityModel = useMemo(
    () => buildShipmentColumnVisibilityModel(columns),
    [columns],
  );

  const handleExport = async (params) => {
    try {
      const response = await exportShipments(params);
      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `shipments_export_${dayjs().format("DD-MM-YYYY")}.csv`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      setExportModalOpen(false);
    } catch (error) {
      console.error("Error exporting shipments:", error);
    }
  };

  return (
    <Box width="100%">
      <LGModal
        open={exportModalOpen}
        handleClose={() => setExportModalOpen(false)}
        header="Exportar Embarques"
      >
        <ShipmentExportModal companyId={companyId} onSubmit={handleExport} />
      </LGModal>

      <LGModalCrud
        props={{
          actions: ["create", "update", "delete", "detail"],
          data: { companyId },
          fetchFunction: getShipmentList,
          deleteFunction: deleteShipment,
          search: true,
          searchParam: "searchTerm",
          searchPlaceholder: "Buscar...",
          customButtons: [
            {
              label: "Exportar CSV",
              icon: "file_download",
              color: "primary",
              onClick: () => setExportModalOpen(true),
            },
          ],
          detailMenu: [
            {
              label: "Documentos",
              handler: () => {},
              header: "Documentos",
              body: <UpdateFileForm />,
            },
            {
              label: "Contenedores",
              handler: () => {},
              header: "Contenedores",
              body: <ManageShipmentContainers />,
            },
            {
              label: "Incrementables",
              handler: () => {},
              header: "Incrementables",
              body: <ShipmentIncrementalsForm />,
            },
          ],
          columns,
          addModalData: {
            header: "Agregar Embarque",
            body: <ShipmentForm companyId={companyId} />,
          },
          editModalData: {
            header: "Editar Embarque",
            body: <ShipmentEditForm companyId={companyId} />,
          },
          dataGridProps: {
            columnHeaderHeight: 68,
            initialState: {
              columns: {
                columnVisibilityModel,
              },
            },
            sx: {
              "& .MuiDataGrid-cell": {
                display: "flex",
                alignItems: "center",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                whiteSpace: "normal",
                lineHeight: 1.2,
                textOverflow: "clip",
              },
            },
          },
        }}
      />
    </Box>
  );
}
